import script from "./AdminEditApartment.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEditApartment.vue?vue&type=script&setup=true&lang=js"

import "./AdminEditApartment.vue?vue&type=style&index=0&id=ac657982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac657982"]])

export default __exports__